import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './layouts/Layout';
import Home from './pages/Home';
import Sobre from './pages/Sobre';
import Dizimos from './pages/Dizimos';
import Eventos from './pages/Ministerios';
import Agenda from './pages/Agenda';
import Contato from './pages/Contato';
import Palavras from './pages/Palavras';
import DeclaracaoFe from './pages/DeclaracaoFe';
import NotFound from './pages/NotFound';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/sobre" element={<Sobre />} />
          <Route path="/dizimos" element={<Dizimos />} />
          <Route path="/eventos" element={<Eventos />} />
          <Route path="/ministerios" element={<Eventos />} />
          <Route path="/agenda" element={<Agenda />} />
          <Route path="/palavras" element={<Palavras />} />
          <Route path="/declaracao-de-fe" element={<DeclaracaoFe />} />
          <Route path="/contato" element={<Contato />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
